// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LocationMarkerIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LocationMarkerIcon" ref={forwardedRef} {...props}>
      <path d="M10 10.67c1.49 0 2.7-1.213 2.7-2.71A2.705 2.705 0 0 0 10 5.25c-1.49 0-2.7 1.214-2.7 2.71a2.705 2.705 0 0 0 2.7 2.71m0-1.506A1.2 1.2 0 0 1 8.8 7.96 1.2 1.2 0 0 1 10 6.756c.662 0 1.2.54 1.2 1.204A1.2 1.2 0 0 1 10 9.164" />
      <path d="M11.052 16.853C12.74 14.823 16 10.58 16 8.087 16 4.726 13.314 2 10 2S4 4.726 4 8.088c0 2.497 3.343 6.75 5.065 8.775.597.703 1 1.137 1 1.137s.397-.439.987-1.148m2.687-6.486c-.509.993-1.203 2.058-1.922 3.055a46 46 0 0 1-1.765 2.282 46 46 0 0 1-1.814-2.294c-.735-.998-1.444-2.063-1.962-3.055C5.732 9.317 5.5 8.548 5.5 8.089c0-2.546 2.03-4.582 4.5-4.582s4.5 2.036 4.5 4.582c0 .468-.23 1.241-.761 2.28" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LocationMarkerIcon = /* @__PURE__ */ Object.assign(
  LocationMarkerIconComponent,
  { displayName: 'LocationMarkerIcon' },
);
